import { render, staticRenderFns } from "./box7.vue?vue&type=template&id=083b7eaa&scoped=true&"
import script from "./box7.vue?vue&type=script&lang=js&"
export * from "./box7.vue?vue&type=script&lang=js&"
import style0 from "./box7.vue?vue&type=style&index=0&id=083b7eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b7eaa",
  null
  
)

export default component.exports